export default __webpack_public_path__ + "static/media/no-notifications.e7cb542f.svg";